import styled from 'styled-components';

export const DateOrNotification = styled.div`
  padding: 10px 0;
  display: flex;
  font-family: ${(props) => props.theme.typography.fontFamily};
  font-weight: 400;
  font-size: 14px;
  justify-content: center;
  color: ${(props) => props.theme.newPalette.neutral.N400};
`;

export const MessageInputBox = styled.textarea`
  height: 150px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  border-radius: 5px;
  border-color: ${(props) => props.theme.newPalette.neutral.N200};
  font-family: ${(props) => props.theme.typography.fontFamily};
  font-weight: 400;
  font-size: 12px;
  padding: 16px;
  &::-webkit-scrollbar {
    width: 3px;
  }
  &::-webkit-scrollbar-thumb {
    background: ${(props) => props.theme.newPalette.neutral.N400};
  }
  &:focus {
    outline: none;
  }
`;

export const MessagesListContainer = styled.div`
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  padding-right: 8px;
  width: 100%;
  &::-webkit-scrollbar {
    width: 2px;
  }
  &::-webkit-scrollbar-thumb {
    background: ${(props) => props.theme.newPalette.neutral.N400};
  }
`;

export const Cross = styled.div<{ open?: boolean }>`
  align-self: 'flex-end';
  &:hover {
    cursor: pointer;
`;

export const Header = styled.div<{ showBorderBottom: boolean }>`
  display: flex;
  border-bottom: ${(props) =>
    props.showBorderBottom
      ? `solid 1px ${props.theme.newPalette.neutral.N400}`
      : 'none'};
  padding-bottom: ${(props) => (props.showBorderBottom ? '20px' : '0')};
  justify-content: space-between;
  align-items: center;
  flex-direction: column;
`;

export const Title = styled.div`
  width: max-content;
  ${(props) => props.theme.newTypography.textStyleBodyLargeSemibold};
`;

export const Placeholder = styled.div`
  width: 24px;
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  padding: 0 8px;
  overflow-y: hidden;
  border-radius: 8px;
  height: 100%;
  font-family: ${(props) => props.theme.typography.fontFamily};
`;

export const MessageInputContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  width: 100%;
  margin-bottom: 10px;
`;

export const MessageContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding-bottom: 10px;
`;

export const MessageBox = styled.div<{
  isReporter: boolean;
  sameAuthor: boolean;
}>`
  display: flex;
  flex-direction: column;
  align-self: ${(props) => (props.isReporter ? 'flex-start' : 'flex-end')};
  margin: 0 0 ${(props) => (props.sameAuthor ? '0px' : '20px')} 0;
`;

export const Minute = styled.div<{ isReporter: boolean }>`
  align-self: ${(props) => (props.isReporter ? 'flex-start' : 'flex-end')};
`;

export const HeaderTextWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  padding: 24px 20px 0 20px;
  justify-content: space-between;
`;

export const ButtonWrapper = styled.div`
  display: flex;
  padding: 20px 20px 30px 20px;
  justify-content: center;
  width: 100%;
`;

export const ModalDescription = styled.section`
  margin: 0;
  ${(props) => props.theme.newTypography.textStyleBody};
  color: ${(props) => props.theme.newPalette.neutral.N600};
  p:last-child {
    margin-bottom: 0;
  }
`;

export const ModalDescriptionBold = styled.span`
  ${(props) => props.theme.newTypography.textStyleBodySemibold};
  color: ${(props) => props.theme.newPalette.neutral.N800};
`;
